import React from 'react'
import { Container, Col, Row, Image } from 'react-bootstrap';
import "../App.css"



export default function About() {
  return (
    <div>
        <Container >
        
            <Col sm={12} md={8} className="center-form">
            <h1>About</h1>
                <p>Thank you for using Zen Journal!!</p>
                <p>Zen journal was made by three aspiring software engineers with an interest in mindfulness and meditation, as the final project of the General Assembly Software Engineering Immersive Course. It was created as an opportunity to demonstrate our skills using React and Express, as well as our ability to work in a team environment. </p>
                <p>We designed the app with two principal philosophies. Firstly, that journaling is an extremely powerful tool on the spiritual path. Not only does journaling allow us to become more aware of the content of our minds but it gives us a sense of our progress and prevents from sitting in rumination rather than actually meditating.  Secondly, that most mediation apps do too much; they are filled with excessive guidance, gadgets, and gismos and ultimately become a distraction themselves. In our design we try not to get in the way but simply allow the user to meditate, then write about what they experience. </p>
                <p>Zen Journal is completely free to use however if you wish to support us you may do so by sharing it with those you think would find it useful as well as providing feedback. Being able to demonstrate that we are able to create a user-friendly application with strong utility is extremely valuable as the three of us begin our careers as software engineers.</p>
                <p>The very best of luck to you on your journey in meditation,</p>
                
                <Row>
                  <Col xs={12} md={4}>
                  <Image roundedCircle={true} id="profile-sam" alt="Sam Hackwood" src="/devs/sam-hackwood-profile.jpeg"></Image>
                  <p><a href="https://github.com/samhackwood" target="_blank" rel="noreferrer">Sam Hackwood</a></p>
                  </Col>
                  <Col xs={12} md={4}>
                  <Image roundedCircle={true} id="profile-yamily" alt="Yamily Benigni" src="/devs/yamily-photo-profile.jpeg"></Image>
                  <p><a href="https://github.com/yamilyn" target="_blank" rel="noreferrer">Yamily Benigni</a></p>
                  </Col>
                  <Col xs={12} md={4}>
                  <Image roundedCircle={true} id="profile-richard" alt="Richard Afrane-Kesey" src="/devs/richard-afrane-kesey-profile.jpg"></Image>
                  <p><a href="https://github.com/richard70UKGithub" target="_blank" rel="noreferrer">Richard Afrane-Kesey</a></p>
                  </Col>
                </Row>
            </Col>
            
        </Container>
    </div>
  )
}